// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3NMvT","colMaxWidth":"Table_colMaxWidth__2i4Py"};